<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  <ng-container matColumnDef="responsible">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.bookingPerson.firstName }} {{ element.bookingPerson.lastName }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="document">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Documento </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.bookingPerson.documentType | documentTypeLabel }} - {{ element.bookingPerson.documentNumber }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="checkOutDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Check-Out </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.checkOutDate | date: 'dd/MM/yyyy' }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-center"> Reserva Nro. </mat-header-cell>
    <mat-cell *matCellDef="let element" class="flex-center"> {{ element.id }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-center"> Estado </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span class="reservation-tag {{ descriptionService.reservationStatus(element.status).class }}">
        {{ descriptionService.reservationStatus(element.status).label }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">

        <!-- Ver reserva -->
        <button mat-menu-item (click)="emitAction('view', element)">
          <mat-icon color="primary">visibility</mat-icon>
          Ver reserva
        </button>

        <!-- Ingresar pago -->
        <button mat-menu-item (click)="emitAction('payment', element)" *ngIf="canRegisterPaymentFn(element)">
          <mat-icon color="success">attach_money</mat-icon>
          Ingresar pago
        </button>

        <!-- Editar reserva -->
        <button mat-menu-item (click)="emitAction('edit', element)" *ngIf="canEditFn(element)">
          <mat-icon color="accent">edit</mat-icon>
          Editar
        </button>

        <!-- Check-In -->
        <button mat-menu-item (click)="emitAction('checkIn', element)" *ngIf="canCheckInFn(element)">
          <mat-icon class="success">login</mat-icon>
          Check-In
        </button>

        <!-- Check-Out -->
        <button mat-menu-item (click)="emitAction('checkOut', element)" *ngIf="canCheckOutFn(element)">
          <mat-icon color="warn">logout</mat-icon>
          Check-Out
        </button>

        <!-- Cancelar -->
        <button mat-menu-item (click)="emitAction('cancel', element)" *ngIf="canCancelFn(element)">
          <mat-icon color="warn">highlight_off</mat-icon>
          Cancelar
        </button>

      </mat-menu>

    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="errorClassFn(row)"></mat-row>
</mat-table>

<mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[10,50,100]"
  (page)="onPageChange($event)">
</mat-paginator>